import { render, staticRenderFns } from "./LeftoverModal.vue?vue&type=template&id=5732971e&"
import script from "./LeftoverModal.vue?vue&type=script&lang=js&"
export * from "./LeftoverModal.vue?vue&type=script&lang=js&"
import style0 from "./LeftoverModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports